/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const TypeChecking = {
    AlphaNumericSpecial: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^ A-Za-z0-9_@.,/#&+-/!/?":;'/(/)]*$/g, '');
        return AlphaNumeric;
    },
};